import GlobalMenu from './GlobalMenu.vue'
export default GlobalMenu
